import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';
import _groupBy from 'lodash/groupBy';
import _map from 'lodash/map';
import moment from 'moment';
import { RouteTransition, presets } from 'react-router-transition';

import { getStartEndTimesBasedOnBookingStatus } from '../../util/bookingHelpers';

import ErrorModalContainer from '../../containers/ErrorModalContainer';
import AppBarContainer from '../../containers/AppBarContainer';
import SnackbarContainer from '../../containers/SnackbarContainer';
import CalendarDay from './CalendarDay';
import NoBookingsMessage from './NoBookingsMessage';
import FloatingActionButton from '../Common/FloatingActionButton';

import { BOOKING_STATUS_CANCELLED } from '../../constants/booking';

import './Calendar.css';

export default class Calendar extends Component {
    static propTypes = {
        bookings: PropTypes.object,
        person: PropTypes.object,
        trackCreateBookingClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleCreateBookingClick = this.handleCreateBookingClick.bind(this);
    }

    handleCreateBookingClick() {
        browserHistory.push(`/bookings/create`);
        this.props.trackCreateBookingClick();
    }

    render() {
        // Group all the bookings by day
        const { bookings, user, person } = this.props;

        const visibleBookings = _
            .chain(bookings)
            .filter(booking => booking.statusId !== BOOKING_STATUS_CANCELLED)
            .sortBy(visibleBookings, (booking) => {
                const { start } = getStartEndTimesBasedOnBookingStatus(booking);
                return start.unix();
            })
            .value();

        const bookingsByDay = _groupBy(visibleBookings, (booking) => {
            if (!booking) {
                return;
            }

            const { start } = getStartEndTimesBasedOnBookingStatus(booking);
            return start.format(`DDD YYYY`);
        });

        const bookingsJsx = _map(bookingsByDay, (dayBookings, i) => {
            return (
                <CalendarDay
                    key={i}
                    bookings={dayBookings}
                />
            );
        });

        const noBookingsMessageJsx = bookingsJsx.length === 0
            ? <NoBookingsMessage />
            : null;

        const canCreateBooking = user.permissions && user.permissions.canCreateBooking;
        const canDrive = person.permissions && person.permissions.canDrive;

        // TODO: When book on behalf is added, this will only need to check canCreateBooking
        const floatingActionBarJsx = canCreateBooking && canDrive
            ? <FloatingActionButton onClick={this.handleCreateBookingClick}>
                <i className="material-icons">&#xE145;</i>
              </FloatingActionButton>
            : null;

        return (
            <div className="calendar">
                <ErrorModalContainer />
                <AppBarContainer />
                <SnackbarContainer />
                {floatingActionBarJsx}
                {bookingsJsx}
                {noBookingsMessageJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Calendar/Calendar.jsx